"use client";

import HeroSection from "@/components/hero/HeroSection";
import NewsSection from "@/components/news/NewsSection";
import RegionSection from "@/components/region/RegionSection";
import QualitySection from "@/components/quality/QualitySection";
import TerritorySection from "@/components/territory/TerritorySection";
import CoffeeCharacteristicsSection from "@/components/coffee/CoffeeCharacteristicsSection";
import OrganizationSection from "@/components/organization/OrganizationSection";
import AssociatesList from "@/components/associates/AssociatesList";

export default function HomePage() {
  return (
    <>
      <HeroSection />
      <NewsSection />
      <RegionSection />
      <QualitySection />
      <TerritorySection />
      <CoffeeCharacteristicsSection />
      <OrganizationSection />
      <AssociatesList />
    </>
  );
}
